import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
//import Button from '@mui/material/Button';
import {Dataset} from './Inc';
import TwinInput from './TwinInput';
import useStyles from './Styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import BottomButtons from './BottomButtons';
import {Theme} from './Theme';

interface ItemSpecSampleProps {
	isOpen:boolean,
	close():void,
}

interface ItemInputParams {
    links:Dataset[],
    specs:Dataset[],
    photo_ids:number[],
	//tax_per: number,
	tags:string[],
}

const ItemLinkSample = (props:ItemSpecSampleProps)=> {
	const classes = useStyles();
	const fullScreen = useMediaQuery(Theme.breakpoints.down('sm'));

    const changeParamTwin = (id:keyof ItemInputParams,index:number,value1:string,value2:string)=>{

    }

	return (
		<Dialog
			fullScreen={fullScreen}
			open={props.isOpen}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			fullWidth={true}
			maxWidth="md"
			disableEscapeKeyDown={true}
			onClose={(event: object, reason: string) =>{
				if( reason!=="backdropClick" ){
					props.close();
				}
			}}
		>
			<DialogTitle color='primary'>詳細情報の入力例</DialogTitle>
			<DialogContent dividers>
				<TwinInput value1="My Grandmother's Spaceship" value2="https://goisagi.retro-ink.com/grandm" name1="リンク先1" name2="URL" maxLength1={30} maxLength2={300} placeholder1="サイトやSNSのタイトル" placeholder2="http://～" change={changeParamTwin} id="links" index={0}/>
				<TwinInput value1="創作ブログ" value2="https://quaqoostore.hatenablog.com/" name1="リンク先2" name2="URL" maxLength1={30} maxLength2={300} placeholder1="サイトやSNSのタイトル" placeholder2="http://～" change={changeParamTwin} id="links" index={0}/>
				<TwinInput value1="有限会社レトロインク" value2="https://www.retro-ink.com/" name1="リンク先3" name2="URL" maxLength1={30} maxLength2={300} placeholder1="サイトやSNSのタイトル" placeholder2="http://～" change={changeParamTwin} id="links" index={0}/>
				<TwinInput value1="" value2="" name1="リンク先4" name2="URL" maxLength1={30} maxLength2={300} placeholder1="サイトやSNSのタイトル" placeholder2="http://～" change={changeParamTwin} id="links" index={0}/>
				<TwinInput value1="" value2="" name1="リンク先5" name2="URL" maxLength1={30} maxLength2={300} placeholder1="サイトやSNSのタイトル" placeholder2="http://～" change={changeParamTwin} id="links" index={0}/>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<BottomButtons button1='閉じる' onClick1={props.close} top={0} bottom={0}/>
			</DialogActions>
		</Dialog>
	);
}

export default ItemLinkSample;
